<template>
  <div>
    <el-upload
      :accept="accept"
      v-if="imageUrl.length < length && !onlyshow"
      :action="`${api.domain}api/common/upload`"
      :data="{
        token: $store.state.token
      }"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
    >
      <button type="button" class="upBtn">{{ title }}</button>
    </el-upload>
    <div
      style="font-size:12px;"
      :width="defaultWid"
      v-if="onlyshow && imageUrl.length === 0"
    >
      暂无文件
    </div>
    <div style="font-size:12px;" :width="defaultWid" v-if="imageUrl.length > 0">
      <a target="_blank" class="up-file" :href="imageUrl[0]['viewurl']">
        {{ imageUrl[0].name ? imageUrl[0].name : "预览文件" }}
      </a>
      <i
        title="删除"
        v-if="!onlyshow"
        @click="del"
        class="el-icon-delete del"
      ></i>
    </div>
  </div>
</template>
<script>
import config from "@/plugins/config.js";
import Api from "@/plugins/axios.js";
export default {
  props: {
    // 只是显示模式？
    onlyshow: {
      default: false,
      type: Boolean
    },
    title: {
      default: "请上传文件",
      type: String
    },
    defaultWid: {
      default: 140,
      type: Number
    },
    length: {
      default: 1,
      type: Number
    },
    value: {
      default: null,
      type: String
    },
    accept: {
      default: "jpg,png,bmp,jpeg,gif,xls,xlsx,pdf,doc,docx",
      type: String
    }
  },
  data() {
    return {
      api: Api,
      // 图片列表
      imageUrl: []
    };
  },
  computed: {
    srcList() {
      return this.imageUrl.map(function name(params) {
        return params.domain_url;
      });
    }
  },
  watch: {
    value() {
      if (this.value) {
        let viewurl = "";
        if (this.value.indexOf("http") < 0) {
          viewurl = config.apidomain + this.value;
        }
        this.imageUrl = [
          { url: this.value, domain_url: viewurl, viewurl: viewurl }
        ];
      }
    }
  },
  mounted() {
    if (this.value) {
      let viewurl = this.value;
      if (viewurl.indexOf("http") < 0) {
        viewurl = config.apidomain + viewurl;
      }
      this.imageUrl = [
        {
          url: this.value,
          domain_url: "",
          viewurl: viewurl,
          name: "点击预览上传文件"
        }
      ];
    }
  },
  methods: {
    // 删除
    del() {
      this.imageUrl = [];
      this.$emit("input", "");
    },
    // 上传完成方法
    handleAvatarSuccess(res) {
      if (res.code === 1) {
        const data = res.data;
        this.imageUrl = [res.data];
        console.log(this.imageUrl);
        this.$emit("input", data.url);
      } else {
        this.$msgbox({ title: "提示", type: "error", message: res.msg });
      }
    },
    // 上传之前
    beforeAvatarUpload() {
      return true;
    }
  }
};
</script>
<style scoped>
.del {
  color: red;
}
</style>
